import { Button } from "components/button/Button";
import { useIsMobile } from "hooks/use-is-mobile";

type Props = {
  onConfirm: () => void;
  onCancel?: () => void;
  disableConfirm?: boolean;
  hideCancel?: boolean;
  confirmText: string;
  cancelText?: string;
  confirmClassName?: string;
  cancelClassName?: string;
  justifyActions?: "between" | "end" | "start";
  actionsClassName?: string;
  actionsDefaultSize?: "sm" | "md" | "lg";
};

export default function ModalFooter({
  onConfirm,
  onCancel,
  confirmText,
  disableConfirm = false,
  hideCancel = false,
  cancelText = "Avbryt",
  confirmClassName = "",
  cancelClassName = "",
  justifyActions = "between",
  actionsClassName = "",
  actionsDefaultSize = "md"
}: Props) {
  const isMobile = useIsMobile();
  return (
    <div
      className={`d-flex align-items-center justify-content-${justifyActions} ${actionsClassName}`}
    >
      {!hideCancel && (
        <Button
          color={"outline"}
          onClick={onCancel || (() => {})}
          size={isMobile ? "sm" : actionsDefaultSize}
          className={cancelClassName}
        >
          {cancelText}
        </Button>
      )}
      <Button
        color={"tertiary"}
        size={isMobile ? "sm" : actionsDefaultSize}
        onClick={onConfirm}
        disabled={disableConfirm}
        className={`${hideCancel ? "" : "ml-4"} ${confirmClassName}`}
      >
        {confirmText}
      </Button>
    </div>
  );
}
